module.exports = __webpack_public_path__ + "img/swiper_02.ac2ca78d.jpg";